<template>
    <div class="ur-scheduler">
        <!--  Calendar   -->
        <div class="ur-scheduler__calendar-wrapper">
            <calendar-view
                :events="dumpItems"
                :show-date="showDate"
                :selected-date="selectedDate"
                :holiday="holiday"
                @click-date="clickDate"
                @click-item="clickItem"
            >
                <template #header="{headerProps}">
                    <ur-scheduler-header
                        :header-props="headerProps"
                        :show-date="showDate"
                        @input="setShowDate"
                    ></ur-scheduler-header>
                </template>
            </calendar-view>
            <div class="ur-scheduler__action" v-if="control">
                <ur-floating-button primary @click="cruOpen"><ur-icon icon="add" sm/></ur-floating-button>
            </div>
            <ur-scheduler-cru-modal ref="cruModal" :mode="mode" @closed="applyItem"/>
        </div>


        <!--  Calendar Floating Button   -->

    </div>
</template>

<script>
import CalendarView from './CalendarView'
import UrSchedulerHeader from './urSchedulerHeader'
import UrSchedulerCruModal from './urSchedulerCrudModal';
import CalendarMathMixin from './CalendarMathMixin'
//ur-scheduler 달력 위에 일정을 표시하여 일정관리를 할 수 있는 컴포넌트입니다.
//#ur-scheduler is a component what carries out the scheduling activity on the calandar.
export default {
    name :'ur-scheduler',
    components: {UrSchedulerCruModal, UrSchedulerHeader, CalendarView},
    mixins: [CalendarMathMixin],
    props : {
        // $ver: v0.2.0
        // 스케쥴러의 아이템(일정)을 입력받습니다. json 형태의 데이터이며 규정된 형식의 키들이 있습니다.
        // #It define button text, and will be ignored when slot is exist.
        // $v-model
        value : {
            type:Array,
            default: () => []
        },
        // $ver: v0.2.0
        // 스케쥴러의 Floating Action 버튼을 추가합니다.
        // #Decide whether to use the Floating action button.
        // $tags IDE
        control: {
            type: Boolean,
            default: false
        },
        // $ver: v0.2.0
        // 휴일을 표시합니다. 스케쥴러에 일자가 빨간색으로 나옵니다.
        // #Set on holiday. Red color is applied to the scheduler date number.
        // $tags IDE
        holiday: { type: Array, default: () => [] },
    },
    data() {
        return {
            showDate: new Date(),
            selectedDate: new Date(),
            mode: 'add',
            editTargetItem: {},
            dumpItems: [],
        }
    },
    computed : {
    },
    watch: {
    },
    created(){
        this.buildDumpItem();
    },
    methods:{
        // @vuese
        // $ver: v0.2.0
        // $return: N/A
        // 스케쥴러 내 데이터 조작(CRUD)을 위한 dump 데이터 생성
        // #Set on dump data for CRUD events
        buildDumpItem(){
            if (!!this.value) {
                this.value.forEach((item, idx) => {
                    this.dumpItems.push(item);
                });
            }
        },
        // @vuese
        // $ver: v0.2.0
        // $return: N/A
        // 선택한 일자(selectedDate)의 값을 조정한다.
        // #Set on 'selectedDate' value.
        setSelectedDate(d) {
            this.selectedDate = d
        },
        // @vuese
        // $ver: v0.2.0
        // $return: N/A
        // showDate의 값을 조정한다.
        // #Set on 'showDate' value by $emit & events
        setShowDate(d) {
            this.showDate = d;
            this.setSelectedDate(d);
        },
        // @vuese
        // $ver: v0.2.0
        // $return: N/A
        // Floating Button 클릭 시 일정 추가 모달을 오픈한다.
        // #When clicked floating button, open to Modal for plan add
        cruOpen(){
            this.mode = 'add';
            this.$refs.cruModal.open();
        },
        // @vuese
        // $ver: v0.2.0
        // $return: N/A
        // 스케쥴러에서 Cell(일자)을 클릭했을 경우의 표시와 selectedDate를 변경하는 이벤트를 호출한다.
        // #When user click on the cell in Scheduler, Set on 'selectedDate' value.
        clickDate(date, event){
            let prevSelected = 'd' + this.isoYearMonthDay(this.selectedDate);
            let nextSelected = 'd' + this.isoYearMonthDay(date);
            let prevDom = document.getElementsByClassName(prevSelected);
            if(!!prevDom){
                prevDom[0].classList.remove('selected')
            }
            event.currentTarget.classList.add('selected');
            this.setSelectedDate(date);
            if(document.getElementsByClassName(nextSelected)[0].classList.contains("outsideOfMonth")){
                this.setShowDate(date);
            }
        },
        // @vuese
        // $ver: v0.2.0
        // $return: N/A
        // 스케쥴러에서 등록된 일정을 클릭했을 경우, 상세 Modal(수정가능)을 오픈한다.
        // #When user click on the event in Cell, open to detail modal(possible to edit).
        clickItem(item){
            this.mode = 'edit';
            this.editTargetItem = item;
            this.$refs.cruModal.open(item.originalEvent);
        },
        // @vuese
        // $ver: v0.2.0
        // $return: N/A
        // CRUD를 위한 모달에서 이후 일정를 스케쥴러에 적용시키며, v-model의 input 이벤트를 emit 한다.
        // #After the CRUD modal process, apply to content to scheduler. And, occur an 'input' $emit
        applyItem(mode, item){
            if(mode === 'delete' || mode === 'edit'){
                this.dumpItems.splice(this.dumpItems.indexOf(this.editTargetItem.originalEvent), 1);
            }
            if(mode === 'add' || mode === 'edit'){
                this.dumpItems.push(item);
            }
            // $ver: v0.2.0
            // $arg: updated v-model value
            // v-model에 설정된값을 업데이트합니다.
            // # update v-model value.
            this.$emit('input', this.dumpItems);
        }
    }
};
</script>
